var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 102,
    viewBox: "0 0 118 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.138 7H37.8574L38.0605 7.57793L43.0128 21.4951L103.451 21.5503C103.451 21.5503 105.641 21.6899 106.857 22L106.731 21.949V9.92774C106.731 8.30871 105.57 7 104.138 7Z",
    fill: "#95D6B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.454 20.8151L43.23 20.7573L38.1314 6.17208L35.9754 0H6.19306C3.06678 0 0.537109 2.91165 0.537109 6.50865V95.4922C0.537109 99.0846 3.06678 102 6.19306 102H111.878C115.004 102 117.537 99.0846 117.537 95.4922V34.2659C117.537 28.0843 113.897 22.8831 108.96 21.2864C107.708 20.9614 105.454 20.8151 105.454 20.8151ZM116.281 87.4613V92.3177H1.80158V87.4613H116.281Z",
    fill: "#63686E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.465 87H0.464844L0.501165 93H117.465V87Z",
    fill: "#82BFAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload-file.30400353a7171325a387febf93ffd8b2.svg";
export { ForwardRef as ReactComponent };